import { ReactNode } from "react";
import { Modal as ModalNext, ModalContent, ModalHeader, ModalBody, ModalFooter } from "@heroui/react";

type ModalProps = {
    size?: "sm" | "xs" | "md" | "lg" | "xl" | "2xl" | "3xl" | "4xl"| "5xl" | "full" | undefined;
    placement?: "center" | "auto" | "top" | "top-center" | "bottom" | "bottom-center" | undefined;
    isOpen: boolean;
    setIsOpen: (isOpen: boolean) => void;
    header?: string | ReactNode;
    classHeader?: string;
    body?: string | ReactNode;
    classBody?: string;
    footer?: string | ReactNode;
    classFooter?: string;
    hideCloseButton?: boolean;
};

export default function Modal({ size='sm', placement='center', isOpen, setIsOpen, header, classHeader, body, classBody, footer, classFooter, hideCloseButton }: ModalProps) {
    return (
        <ModalNext
            size={size}
            backdrop="blur"
            isOpen={isOpen}
            onOpenChange={setIsOpen}
            hideCloseButton={window.innerWidth > 330 ? hideCloseButton : true}
            placement={placement}
        >
            <ModalContent>
                <>
                    {header && (
                        <ModalHeader className={classHeader}>
                            {typeof header === "string" ? <span>{header}</span> : header}
                        </ModalHeader>
                    )}
                    {body && (
                        <ModalBody className={classBody}>
                            {typeof body === "string" ? <p>{body}</p> : body}
                        </ModalBody>
                    )}
                    {footer && (
                        <ModalFooter className={classFooter}>
                            {typeof footer === "string" ? <span>{footer}</span> : footer}
                        </ModalFooter>
                    )}
                </>
            </ModalContent>
        </ModalNext>
    );
}
